<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header fw-bold">{{ $t("views.objective.kpiTable.heading") }}</div>
        <div class="card-body">
          <div class="bg-white">

            <!-- Header -->
            <div class="bg-primary text-light px-3">
              <div class="row">
                <div class="col-3 px-1 py-1"> {{ $t("views.objective.kpiTable.kpiName") }} </div>
                <div class="col-1 px-1 py-1"> {{ $t("views.objective.kpiTable.kpiUnit") }} </div>
                <div class="col-2 px-1 py-1"> {{ $t("views.objective.kpiTable.responsible") }} </div>
                <div class="col-1 text-end px-1 py-1 pe-5 border-2 border-start"> {{ $t("views.objective.kpiTable.period") }} </div>
                <div class="col-1 text-end px-1 py-1 pe-3"> {{ $t("views.objective.kpiTable.objective") }} </div>
                <div class="col-1 text-end px-1 py-1 border-2 border-start"> {{ $t("views.objective.kpiTable.actual") }} </div>
                <div class="col-1 text-end px-1 py-1 pe-3"> {{ $t("views.objective.kpiTable.deviation") }} </div>
                <div class="col-1 text-end px-1 py-1 border-2 border-start"> {{ $t("views.objective.kpiTable.forecast") }} </div>
                <div class="col-1 text-end px-1 py-1"> {{ $t("views.objective.kpiTable.deviation") }} </div>
              </div>
            </div>

            <!-- KPI-Data -->
            <div v-for="kpi in relatedKpis" :key="kpi.id">

              <div v-if="kpi.yearRecords?.length > 0">

                <div v-for="(yr, index) in kpi.yearRecords" :key="kpi.id + '-' + yr.year" class="row px-3 border-bottom">

                  <div class="col-3 my-auto col-kpi-name px-1">
                    <template v-if="index === 0">
                      <svg v-if="kpi.status_deviation === 'H'" class="bi" width="16" height="16" fill="currentColor"> <title>{{ $t("views.kpi.edit.rating.H") }}</title > <use xlink:href="@/assets/icons/icons.svg#kpi-high-values" /> </svg>
                      <svg v-else-if="kpi.status_deviation === 'L'" class="bi" width="16" height="16" fill="currentColor"> <title>{{ $t("views.kpi.edit.rating.L") }}</title > <use xlink:href="@/assets/icons/icons.svg#kpi-low-values" /> </svg>
                      <svg v-else class="bi" width="16" height="16" fill="currentColor"> <title>{{ $t("views.kpi.edit.rating.N") }}</title > <use xlink:href="@/assets/icons/icons.svg#kpi" /> </svg>
                      &nbsp;
                      <a @click="selectKPI(kpi.id)" :href="'#kpiPeriodsModal' +selectedKPI.id" data-bs-toggle="modal">{{ kpi.name }}</a>
                    </template>
                  </div>
                  <div class="col-1 my-auto px-1">
                    <template v-if="index === 0">
                        {{ kpi.unit }}
                    </template>
                  </div>
                  <div class="col-2 my-auto px-1">
                    <template v-if="index === 0">
                        {{ kpi.responsible.name }}
                    </template>
                  </div>

                  <div class="col-1 text-end my-auto px-1 pe-5 py-1 border-2 border-start"> {{ yr.year || '-' }} </div>
                  <div class="col-1 text-end my-auto px-1 pe-3"> {{ yr.record?.objective || '-' }} </div>
                  <div class="col-1 text-end my-auto px-1 py-1 border-2 border-start"> {{ yr.record?.actual || '-' }}  &nbsp; </div>
                  <div class="col-1 text-end my-auto px-1 pe-3">
                    <span :class="getDevColor(unFormatNumber(yr.record?.actual), unFormatNumber(yr.record?.objective), kpi.status_deviation, kpi.status_yellow)"> {{ yr.record?.devActualObjective || '' }} </span>
                  </div>
                  <div class="col-1 text-end my-auto px-1 py-1 border-2 border-start"> {{ yr.record?.forecast || '-' }} &nbsp; </div>
                  <div class="col-1 text-end my-auto px-1">
                    <span :class="getDevColor(unFormatNumber(yr.record?.forecast), unFormatNumber(yr.record?.objective), kpi.status_deviation, kpi.status_yellow)"> {{ yr.record?.devForecastObjective || '' }} </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <KPIPeriodsModal :kpi="selectedKPI"></KPIPeriodsModal>
  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'
import KPIPeriodsModal from '../../components/monitoring/KPIPeriodsModal.vue'

export default {
  name: 'KPITable',
  props: ['kpis'],
  components: {
    KPIPeriodsModal
  },

  computed: {
    selectedObjective () {
      return this.$store.state.selectedObjective
    },

    selectedKPI () {
      return this.$store.state.selectedKPI
    },

    relatedKpis () {
      const validFrom = new Date(this.$store.state.selectedObjective.validFrom).getFullYear()
      const validTo = new Date(this.$store.state.selectedObjective.validTo).getFullYear()

      // Liste aller Jahre erzeugen
      const years = []
      for (let y = validFrom; y <= validTo; y++) {
        years.push(String(y))
      }

      return this.kpis.map(kpi => {
        // Für jedes Jahr den passenden Jahres-Record finden
        const yearRecords = years.map(year => {
          const record = kpi.records.find(r => {
            const p = String(r.period).trim()
            return p.length === 4 && p === year
          })

          return {
            year,
            record: record || null
          }
        })

        return {
          ...kpi,
          yearRecords
        }
      })
    }

  },

  methods: {
    getRecordStatus (conversion) {
      return conversion >= 100 ? 'bg-success' : conversion >= 95 ? 'bg-warning' : 'bg-danger'
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    },
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    },
    getDevColor (actual, plan, statusDeviation, statusYellow) {
      return formatUtils.getDevColor(actual, plan, statusDeviation, statusYellow)
    },
    async selectKPI (kpiId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getKPI', { mode: 'manage', id: kpiId })
      this.$store.commit('SET_LOADING_STATUS', false)
    }

  }
}
</script>

<style scoped>
.card-body .bg-dark {
  --bs-bg-opacity: 0.8;
}
.col-unit {
  width: 12.33333333%;
}
.col-kpi-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.col-context {
  width: 4.33333333%;
}
.col-total {
  width: 29%;
}
.select-th {
  background-color: transparent;
  border: 1px solid;
  border-radius: 0.3rem;
}
.progress-label {
  transform: translate(-50%, -50%);
}
</style>
